/* WristPop Strap Finder — PAGE variant (landing page, all 8 models in one instance).
 *
 * The PDP finder is pinned to one product. On the landing page there is no product context,
 * so this variant carries every model's data and switches between them in place: tapping a
 * card in "Which one is yours?" selects that model here and scrolls to it.
 *
 * WHY THIS IS CHEAP: every model offers all 14 strap colours, so the Flickity carousel — the
 * only expensive thing on screen — is IDENTICAL for all eight. Switching a model therefore
 * never rebuilds the carousel; it only swaps the case axis, the watch-head overlay, the
 * variant map and the price. That is a handful of DOM writes.
 *
 * Data per model:  crown, head image, price/compare, and its OWN variant map.
 * Data shared:     the BYO variant map per crown, the case list per crown, colour artwork.
 * Merge order:     BYO first, model's own second (last wins) — so an on-model combination
 *                  buys that model's listing and an off-model one falls back to Build Your
 *                  Own, exactly as the PDP finder behaves.
 */
(function () {
  // diagnostic marker: lets us tell "script never executed" apart from "init found nothing"
  try { window.__wpfPageFinder = { loaded: true, inits: 0, booted: 0 }; } catch (e) {}

  function slug(s) { return String(s).toLowerCase().replace(/\s+/g, '-'); }

  function boot(root) {
    var cfgEl = root.querySelector('#wpf-page-config');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var C = cfg.colours || {};
    var strapAxis = (cfg.strapColours || []).filter(function (c) { return C[c] && C[c].strapFull; });
    if (!strapAxis.length) return;

    var container   = root.querySelector('.wpf-reverse');
    var nameEl      = root.querySelector('[data-wpf-name]');
    var counterEl   = root.querySelector('[data-wpf-counter]');
    var caseNameEl  = root.querySelector('[data-wpf-case-name]');
    var modelNameEl = root.querySelector('[data-wpf-model-name]');
    var pdpLink     = root.querySelector('[data-wpf-pdp-link]');
    var ovCase      = root.querySelector('.wpf-ov-case');
    var ovHead      = root.querySelector('.wpf-ov-head');
    var ctaEl       = root.querySelector('[data-wpf-cta]');
    var ctaSummary  = root.querySelector('[data-wpf-cta-summary]');
    var ctaPrice    = root.querySelector('[data-wpf-cta-price]');
    var ctaCompare  = root.querySelector('[data-wpf-cta-compare]');
    var ctaBtn      = root.querySelector('[data-wpf-cta-btn]');

    var model = null, handle = null, caseAxis = [], caseIdx = 0;
    var selectedStrap = strapAxis[0], sets = {}, started = false;

    function strapUrl(c) { return C[c] && C[c].strapFull; }
    function claspUrl(c) { return C[c] && C[c].clasp; }
    function caseUrl(c)  { return C[c] && C[c]['caseFrame' + (model ? model.crown : '12')]; }

    // Drive the carousel to a named strap. The engine builds the carousel through
    // jQuery Flickity, so we steer it the same way rather than reaching into its internals.
    function selectStrapByName(name) {
      var idx = strapAxis.indexOf(name);
      if (idx < 0) return;
      selectedStrap = name;
      if (!started) return;            // engine not up yet — re-applied after loadWatches
      try {
        var $c = window.jQuery && window.jQuery(container);
        if ($c && $c.flickity) $c.flickity('select', idx, false, true);
      } catch (e) {}
    }

    function lookSet() { return sets[caseAxis[caseIdx] + '|' + selectedStrap] || null; }

    function updateCTA() {
      if (!ctaEl || !model) return;
      var set = lookSet(), caseColour = caseAxis[caseIdx];
      if (ctaSummary) ctaSummary.textContent = caseColour + ' case & clasp · ' + selectedStrap + ' strap';
      if (ctaPrice)   ctaPrice.textContent = model.price || '';
      if (ctaCompare) ctaCompare.textContent = (model.compare && model.compare !== model.price) ? model.compare : '';
      ctaBtn.disabled = !set || !set.a;
      ctaBtn.textContent = (set && !set.a) ? 'Not yet available' : (cfg.ctaLabel || 'Add this look to cart');
      ctaEl.hidden = false;
    }

    function addLook() {
      var set = lookSet();
      if (!set || !set.a || ctaBtn.disabled) return;
      var lookTag = (model.short ? model.short + ' · ' : '') + caseAxis[caseIdx] + ' case · ' + selectedStrap + ' strap';
      var props = { _wpf_look: lookTag };
      // wpf-byo-attribution (19 Aug): BYO set SKUs carry crown but not the watch model, so
      // orders through Build Your Own were unattributable. The hidden _model property rides
      // the bundle parent and survives the checkout split onto lineItemGroup.customAttributes
      // (verified on live orders), where build-orders.py reads the set.
      if (model && model.short) props._model = model.short;
      if (set.p && cfg.preorderText) props['Pre-order'] = cfg.preorderText;
      ctaBtn.disabled = true;
      ctaBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: set.i, quantity: 1, properties: props }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || r.status); });
        return r.json();
      }).then(function () {
        ctaBtn.textContent = '✓ Added to cart';
        if (window.CartJS && window.CartJS.getCart) {
          try { window._dlcUserAddToCart = true; window.CartJS.getCart(); } catch (e) {}
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () { ctaBtn.disabled = false; updateCTA(); }, 1800);
      }).catch(function () {
        ctaBtn.textContent = 'Could not add — try again';
        setTimeout(function () { ctaBtn.disabled = false; updateCTA(); }, 2200);
      });
    }
    if (ctaBtn) ctaBtn.addEventListener('click', addLook);

    function paintOverlay() {
      var c = caseAxis[caseIdx];
      if (ovCase) {
        var cu = caseUrl(c);
        if (cu) { ovCase.src = cu; ovCase.classList.add('is-ready'); }
        else { ovCase.removeAttribute('src'); ovCase.classList.remove('is-ready'); }
      }
      if (ovHead && model) {
        if (model.head) { ovHead.src = model.head; ovHead.classList.add('is-ready'); }
        else { ovHead.removeAttribute('src'); ovHead.classList.remove('is-ready'); }
      }
      // match the PDP finder: colour name + position in the case axis, e.g.
      // "White  ·  3/10". The denominator is per-model — crown-12 offers 10 case
      // colours, crown-3 offers 7 — so it is read off caseAxis rather than hardcoded.
      if (caseNameEl) {
        caseNameEl.textContent = caseAxis.length
          ? (c || '—') + '  ·  ' + (caseIdx + 1) + '/' + caseAxis.length
          : (c || '—');
      }
    }

    function updateClasps() {
      var cu = claspUrl(caseAxis[caseIdx]);
      var imgs = container ? container.querySelectorAll('img.wpf-clasp') : [];
      for (var i = 0; i < imgs.length; i++) {
        if (cu) { imgs[i].src = cu; imgs[i].style.display = ''; }
        else { imgs[i].style.display = 'none'; }
      }
    }

    function injectClasps() {
      if (!container) return;
      var cells = container.querySelectorAll('.columns');
      for (var i = 0; i < cells.length; i++) {
        if (!cells[i].querySelector('img.wpf-clasp')) {
          var img = document.createElement('img');
          img.className = 'wpf-clasp';
          img.alt = '';
          cells[i].appendChild(img);
        }
      }
      updateClasps();
    }

    function cycleCase(delta) {
      if (!caseAxis.length) return;
      caseIdx = (caseIdx + delta + caseAxis.length) % caseAxis.length;
      paintOverlay(); updateClasps(); updateCTA();
    }
    var prevBtn = root.querySelector('[data-wpf-case-prev]');
    var nextBtn = root.querySelector('[data-wpf-case-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { cycleCase(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { cycleCase(1); });

    // ---- the whole point: swap model without touching the carousel ----
    function applyModel(h) {
      var m = cfg.models && cfg.models[h];
      if (!m) return false;
      model = m; handle = h;

      caseAxis = (cfg.caseByCrown[m.crown] || []).filter(function (c) {
        return C[c] && C[c]['caseFrame' + m.crown];
      });
      // Open on the model's OWN default variant. Ken curated these per model — OTG Roz
      // defaults to Yellow, Orenji Hachi to Indigo Blue — so the default IS the intended
      // look for that watch, not merely whichever case happened to be on screen.
      caseIdx = 0;
      if (m.defaultCase) {
        var at = caseAxis.indexOf(m.defaultCase);
        if (at > -1) caseIdx = at;
      }
      if (m.defaultStrap) selectStrapByName(m.defaultStrap);

      sets = {};
      var b = (cfg.byo && cfg.byo[m.crown]) || {};
      for (var k in b) { if (k !== '__end') sets[k] = b[k]; }
      for (var k2 in m.own) { if (k2 !== '__end') sets[k2] = m.own[k2]; }

      if (modelNameEl) modelNameEl.textContent = m.short || m.title || '';

      // reflect the active model on the in-finder chip row. Centre it by setting the ROW's
      // scrollLeft directly — scrollIntoView would also scroll every scrollable ancestor,
      // which on first paint would yank the whole page down to the finder.
      var chips = root.querySelectorAll('[data-wpf-model]');
      for (var ci = 0; ci < chips.length; ci++) {
        var on = chips[ci].getAttribute('data-wpf-model') === h;
        if (on) { chips[ci].className += ' is-active'; }
        else { chips[ci].className = chips[ci].className.replace(/\s*is-active/g, ''); }
        chips[ci].setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && chips[ci].parentNode) {
          var row = chips[ci].parentNode;
          if (row.scrollWidth > row.clientWidth) {
            row.scrollLeft = chips[ci].offsetLeft - (row.clientWidth - chips[ci].offsetWidth) / 2;
          }
        }
      }
      if (pdpLink && m.url) { pdpLink.href = m.url; pdpLink.hidden = false; }
      root.setAttribute('data-wpf-active-model', h);

      paintOverlay(); updateClasps(); updateCTA();
      return true;
    }

    // The in-finder model chips drive this finder. Delegated from document so it survives
    // any re-render of the section.
    //
    // 2026-08-18 (Ken): `[data-wpf-model]` is NOT unique on this page — the "Which one is
    // yours?" lineup cards carry it too, and they come FIRST in the DOM. Those are <a> links
    // to their own PDPs and must navigate natively, so anything outside the finder root is
    // ignored here. (Before this, the lineup cards drove the finder instead of navigating.)
    document.addEventListener('click', function (e) {
      var card = e.target && e.target.closest && e.target.closest('[data-wpf-model]');
      if (!card) return;
      if (!root.contains(card)) return;            // lineup card -> let it navigate to its PDP
      var h = card.getAttribute('data-wpf-model');
      if (!cfg.models || !cfg.models[h]) return;   // unknown model -> leave the chip inert
      e.preventDefault();
      applyModel(h);
    });

    applyModel(cfg.defaultModel || Object.keys(cfg.models || {})[0]);

    // ---- shared engine, started once (carousel is model-independent) ----
    var tries = 0;
    (function waitDeps() {
      if (started) return;
      var ok = window.StrapFinderEngine && window.jQuery && window.jQuery.fn
               && window.jQuery.fn.flickity && window.imagesLoaded;
      if (!ok) {
        if (++tries > 100) { if (nameEl) nameEl.textContent = 'Finder unavailable (engine not loaded)'; return; }
        return setTimeout(waitDeps, 100);
      }
      started = true;
      var engine = window.StrapFinderEngine({
        $: window.jQuery,
        container: container,
        overlay: null,
        cropMobile: 'sfnoop=1', cropDesktop: 'sfnoop=1', faceCrop: 'sfnoop=1',
        onSelect: function (sel) {
          if (nameEl) nameEl.textContent = (sel && sel.title) || '';
          if (sel && sel.handle) {
            for (var s = 0; s < strapAxis.length; s++) {
              if (slug(strapAxis[s]) === sel.handle) { selectedStrap = strapAxis[s]; break; }
            }
            updateCTA();
          }
        },
        onCounter: function (cur, total) { if (counterEl) counterEl.textContent = cur + ' / ' + total; }
      });
      var items = [];
      for (var i = 0; i < strapAxis.length; i++) {
        var su = strapUrl(strapAxis[i]);
        items.push({
          head: (model && model.head) || su,
          top: su, bottom: su, topMargin: 0, bottomMargin: 0,
          title: strapAxis[i] + ' strap',
          handle: slug(strapAxis[i]),
          alt: 'Royal Pop with ' + strapAxis[i] + ' strap'
        });
      }
      engine.loadWatches(items);
      // the carousel only exists now, so apply the default strap the model asked for
      selectStrapByName(selectedStrap);
      setTimeout(function () { selectStrapByName(selectedStrap); }, 400);
      paintOverlay();
      updateCTA();
      setTimeout(injectClasps, 50);
      setTimeout(injectClasps, 1500);
    })();
  }

  function init() {
    var roots = document.querySelectorAll('[data-wpf-page-root]');
    for (var i = 0; i < roots.length; i++) {
      (function (root) {
        if (root.getAttribute('data-wpf-init') === '1') return;
        root.setAttribute('data-wpf-init', '1');
        var done = false;
        function go() {
          if (done) return; done = true;
          try { window.__wpfPageFinder.booted++; } catch (e) {}
          boot(root);
        }
        function near() {
          var b = root.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight || 0;
          return b.top < vh + 500 && b.bottom > -500;
        }

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            for (var j = 0; j < entries.length; j++) {
              if (entries[j].isIntersecting) { io.disconnect(); go(); break; }
            }
          }, { rootMargin: '400px 0px' });
          io.observe(root);
        }

        // Visibility is polled rather than driven by events. The observer and scroll
        // listeners both proved unreliable here — an IntersectionObserver created while the
        // viewport had zero height never fires again, and the theme's nested flex wrappers
        // meant window scroll events did not always reach us. A 250ms rect check cannot get
        // into either state, costs nothing, and stops as soon as it boots.
        var ticks = 0;
        (function poll() {
          if (done) return;
          if (near()) return go();
          if (++ticks > 240) return go();   // ~60s: boot regardless rather than never
          setTimeout(poll, 250);
        })();
      })(roots[i]);
    }
  }

  function initAll() {
    try { window.__wpfPageFinder.inits++; } catch (e) {}
    init();
  }

  // Fire on every reasonable trigger. init() guards each root with data-wpf-init, so running
  // repeatedly is free — and it means no single ordering quirk (deferred execution, a theme
  // that re-inserts sections, a zero-height viewport at parse time) can leave the finder dead.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  window.addEventListener('load', initAll);
  setTimeout(initAll, 1200);
  setTimeout(initAll, 4000);
})();

